"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundraiseServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class FundraiseServiceLive {
    cancelFundraiseOffer(companyId, emailDetailsRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/fundraise-offers/cancel`, emailDetailsRequestBody);
            return response.data;
        });
    }
    resendFundraiseOffer(companyId, fundraiseOfferId, actionedByUser) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraise-offers/${fundraiseOfferId}/resend`, {
                actionedByUser,
            });
            return response.data;
        });
    }
    deleteFundraiseRound(companyId, fundraiseId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/fundraises/${fundraiseId}`);
            return response.data;
        });
    }
    updateFundraiseRound(companyId, fundraiseId, fundraiseData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/fundraises/${fundraiseId}`, fundraiseData);
            return response.data;
        });
    }
    getDefaultFundraiseFee(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises/fee/default`);
            return response.data;
        });
    }
    acceptFundraiseTnc(companyId, acceptFundraiseTncRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraises/fundraise-tnc/accept`, acceptFundraiseTncRequestBody);
            return response.data;
        });
    }
    generateFundraiseTnc(companyId, fee) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraises/fundraise-tnc/generate`, { fee });
            return response.data;
        });
    }
    getFundraises(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises`);
            return response.data;
        });
    }
    issueFundraiseOfferToExistingShareholder(companyId, shareholderId, issueFundraiseOfferToExistingShareholderRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.put(`/company/${companyId}/fundraise-offers/${shareholderId}`, issueFundraiseOfferToExistingShareholderRequestBody);
            return response.data;
        });
    }
    issueFundraiseOfferToNewShareholder(companyId, issueFundraiseOfferToNewShareholderRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraise-offers`, issueFundraiseOfferToNewShareholderRequestBody);
            return response.data;
        });
    }
    uploadSubscriptionAgreement(companyId, fundraiseId, docFile) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("doc", docFile, docFile.name);
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraises/${fundraiseId}/subscription-agreement-template`, formData);
            return response.data;
        });
    }
    getSubscriptionAgreementTemplate(companyId, fundraiseId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises/${fundraiseId}/subscription-agreement-template`);
            return response.data;
        });
    }
    getShareholderSubscriptionAgreement(companyId, fundraiseId, fundraiseOfferId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises/${fundraiseId}/subscription-agreements/${fundraiseOfferId}`);
            return response.data;
        });
    }
    updateFundraiseOffer(companyId, fundraiseOfferId, fundraiseOfferUpdate) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/fundraise-offers/${fundraiseOfferId}`, fundraiseOfferUpdate);
            return response.data;
        });
    }
    getFundraiseOffersForShareholder(companyId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraise-offers/shareholder/${shareholderId}`);
            return response.data;
        });
    }
    getFundraiseOffer(companyId, fundraiseOfferId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraise-offers/${fundraiseOfferId}/shareholder/${shareholderId}`);
            return response.data;
        });
    }
    getFundraiseOfferDetails(companyId, fundraiseId, keyword, fundraiseOfferType, page, rowsPerPage, sortBy, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraise-offers/fundraise-offer-details/${fundraiseId}?keyword=${keyword}&activeFundraiseType=${fundraiseOfferType}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
            return response.data;
        });
    }
}
exports.FundraiseServiceLive = FundraiseServiceLive;
//# sourceMappingURL=FundraiseServiceLive.js.map